import { TickList } from '../../../report-pdf/components'

export { TickList }
